import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import EmployeeList from "./EmployeeList";
import EmployeeTabs from "./EmployeeTabs";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";

export const EmployeeRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route path="/:id" element={<EmployeeTabs />} />
      <Route index element={<ProtectedRoute roles={[Role.Admin, Role.DriverAdmin]}><EmployeeList /></ProtectedRoute>} />
    </Routes>
  );
};
